class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content =
      this.mainDetailsToggle.querySelector("summary").nextElementSibling;

    this.mainDetailsToggle.addEventListener(
      "focusout",
      this.onFocusOut.bind(this),
    );
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.classList.remove("open");
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
  }

  connectedCallback() {
    this.menuSpan = this.mainDetailsToggle.querySelector("summary span");
    if (this.menuSpan) {
      this.menuSpan.addEventListener("click", this.onSpanClick.bind(this));
    }

    this.addEventListener("mouseenter", this.onMouseEnter.bind(this));
    this.addEventListener("mouseleave", this.onMouseLeave.bind(this));
  }

  onSpanClick() {
    const url = this.menuSpan.getAttribute("data-url");
    if (url) {
      window.location.href = url;
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (
      document.documentElement.style.getPropertyValue(
        "--header-bottom-position-desktop",
      ) !== ""
    )
      return;
    document.documentElement.style.setProperty(
      "--header-bottom-position-desktop",
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`,
    );
  }

  onMouseEnter() {
    if (window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
      this.mainDetailsToggle.setAttribute("open", "");
    }
  }

  onMouseLeave() {
    if (window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
      this.close();
    }
  }
}

customElements.define("header-menu", HeaderMenu);
